export const QuestPageMobileGrid = {
  size: 100,
  gap: 1,
  name: "QuestPageMobileGrid",
  background: {
    element: "quest_page_main_bg",
    main: {
      height: 100,
    },
  },
  padding: {
    left: 3,
    right: 3,
    top: 2,
    bottom: 2,
    portrate: {
      left: 3,
      right: 3,
      top: 2,
      bottom: 2,
    },
  },

  main: [
    {
      name: "leftgrid",
      size: 100,
      type: "PortrateGridController",
      config: {
        size: 70,
        gap: 1,
        main: [
          {
            name: "empty",
            size: 2,
          },
          {
            name: "header-grid",
            type: "LandscapeGridController",
            size: 10,
            config: {
              size: 100,
              gap: 1,
              name: "header",
              main: [
                {
                  name: "header",
                  size: 80,
                  align: "left",
                  height: 80,
                },
                {
                  name: "empty",
                  size: 10,
                },
                {
                  name: "close",
                  size: 10,
                  align: "top_right",
                  height: 80,
                },
              ],
            },
          },
          {
            name: "empty",
            size: 1,
          },
          {
            name: "content_grid_bottom2",
            size: 21,
            type: "LandscapeGridController",
            config: {
              size: 100,
              gap: 1,
              name: "content",
              main: [
                {
                  name: "quest_daily",
                  size: 75,
                  align: "left_center",
                },
                // {
                //   name: "empty",
                //   size: 5,
                // },
                {
                  name: "quest_claim_btn",
                  size: 25,
                  align: "top_right",
                  bounds: {
                    width: 218,
                    height: 82,
                  },
                },
              ],
            },
          },
          {
            name: "content_grid_bottom",
            size: 18,
            type: "LandscapeGridController",
            config: {
              size: 100,
              gap: 1,
              name: "content",
              main: [
                {
                  name: "quest_1",
                  size: 50,
                  bounds: {
                    width: 497,
                    height: 133,
                  },
                },
                {
                  name: "quest_2",
                  size: 50,
                  bounds: {
                    width: 497,
                    height: 133,
                  },
                },
              ],
            },
          },
          {
            name: "content_grid_bottom1",
            size: 18,
            type: "LandscapeGridController",
            config: {
              size: 100,
              gap: 1,
              name: "content",
              main: [
                {
                  name: "quest_3",
                  size: 50,
                  bounds: {
                    width: 497,
                    height: 133,
                  },
                },
                {
                  name: "quest_4",
                  size: 50,
                  bounds: {
                    width: 497,
                    height: 133,
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "header-grid-portrait",
      type: "LandscapeGridController",
      size: 10,
      config: {
        size: 100,
        gap: 0,
        name: "header-portrait",
        maxWidth: "reel",
        main: [
          {
            name: "header",
            size: 70,
            align: "left",
            height: 70,
          },
          {
            name: "empty",
            size: 20,
          },
          {
            name: "close",
            size: 10,
            align: "right",
            bounds: {
              width: 60,
              height: 60,
            },
          },
        ],
      },
    },
    {
      name: "quest_daily",
      size: 19,
      bounds: {
        width: 497,
        height: 133,
      },
    },
    {
      name: "quest_1",
      size: 18,
      bounds: {
        width: 497,
        height: 133,
      },
    },
    {
      name: "quest_2",
      size: 18,
      bounds: {
        width: 497,
        height: 133,
      },
    },
    {
      name: "quest_3",
      size: 18,
      bounds: {
        width: 497,
        height: 133,
      },
    },
    {
      name: "quest_4",
      size: 18,
      bounds: {
        width: 497,
        height: 133,
      },
    },
    // {
    //   name: "quest_claim_btn",
    //   size: 10,
    //   // height: 85,
    //   align: "center",
    //   bounds: {
    //     width: 218,
    //     height: 82,
    //   },
    // },
    {
      name: "empty",
      size: 4,
    },
  ],
};
